import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import Foto from "../Components/Foto";
import { Modal, Spinner, Table, Button, Form, Badge, Card, Row, Col, Tabs, Tab, Pagination } from 'react-bootstrap';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import {
    FaSearch,
    FaPlus,
    FaStore,
    FaChartBar,
    FaCheckCircle,
    FaBan,
    FaSyncAlt,
    FaCalculator,
    FaFileAlt,
    FaSave,
    FaTrashAlt,
    FaFileUpload,
    FaLock,
    FaCheck,
    FaLink,
    FaFileExcel,
    FaArrowLeft,
    FaCopy
} from "react-icons/fa";

const parseCurrencyToNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return v;
    const s = String(v).replace(/\./g, "").replace(/,/g, ".");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

const formatarMoeda = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseCurrencyToNumber(val));

const formatarApenasNumero = (val) => {
    const num = parseCurrencyToNumber(val);
    if (num <= 0) return '';
    return num.toFixed(2).replace('.', ',');
};

const calcularMargem = (preco, custo) => {
    if (!preco || preco <= 0 || preco === 0.01) return null;
    return ((preco - custo) / preco) * 100;
};

const normalizarProduto = (item) => {
    const codigo = item.codigo ?? item.CODIGO ?? item.seqproduto ?? item.SEQPRODUTO ?? 0;
    const ean = item.ean ?? item.EAN ?? item.ean_principal ?? item.EAN_PRINCIPAL ?? item.codacesso ?? item.CODACESSO ?? '';
    const descricao = item.descricao ?? item.DESCRICAO ?? item.desccompleta ?? item.DESCCOMPLETA ?? '';
    const emb = item.emb ?? item.EMB ?? item.embalagem ?? item.EMBALAGEM ?? 'UN';
    const custo = item.custodia ?? item.CUSTODIA ?? item.custo ?? item.CUSTO ?? item.custo_loja ?? item.PPROD_CUSTO_LOJA ?? 0;
    const pBase = item.precovalidnormal ?? item.PRECOVALIDNORMAL ?? item.precobasenormal ?? item.PRECOBASENORMAL ?? item.preco_loja ?? item.PPROD_PRECO_LOJA ?? 0;
    const pPromoV = item.precovalidpromoc ?? item.PRECOVALIDPROMOC ?? item.promovarejo ?? item.PROMOVAREJO ?? 0;
    const pPromoA = item.promoapp ?? item.PROMOAPP ?? 0;
    
    const secao = item.secao ?? item.SECAO ?? item.secaoproduto ?? item.SECAOPRODUTO ?? item.pprod_secao ?? item.PPROD_SECAO ?? 0;
    const grupo = item.grupo ?? item.GRUPO ?? item.grupoproduto ?? item.GRUPOPRODUTO ?? item.pprod_grupo ?? item.PPROD_GRUPO ?? 0;

    const precos = [parseCurrencyToNumber(pBase), parseCurrencyToNumber(pPromoV), parseCurrencyToNumber(pPromoA)].filter(p => p > 0);
    const menorPreco = precos.length > 0 ? Math.min(...precos) : parseCurrencyToNumber(pBase);

    return {
        codigo: Number(codigo),
        ean: String(ean),
        descricao: String(descricao),
        emb: String(emb),
        custo_loja: parseCurrencyToNumber(custo),
        precobasenormal: parseCurrencyToNumber(pBase),
        promovarejo: parseCurrencyToNumber(pPromoV),
        promoapp: parseCurrencyToNumber(pPromoA),
        preco_loja: menorPreco,
        secao: Number(secao) || 0,
        grupo: Number(grupo) || 0
    };
};

/* Cores distintas para o cabeçalho dos concorrentes */
const CORES_CONCORRENTES = [
    { headerBg: '#1e3a8a', headerText: '#ffffff' }, // Azul Escuro
    { headerBg: '#991b1b', headerText: '#ffffff' }, // Vermelho
    { headerBg: '#166534', headerText: '#ffffff' }, // Verde
    { headerBg: '#854d0e', headerText: '#ffffff' }, // Dourado/Laranja
    { headerBg: '#581c87', headerText: '#ffffff' }, // Roxo
    { headerBg: '#9a3412', headerText: '#ffffff' }, // Laranja Escuro
    { headerBg: '#0f766e', headerText: '#ffffff' }  // Teal/Ciano
];

function ModalListaProdutos({ show, produtos, onSelect, onClose }) {
    if (!show) return null;
    return (
        <Modal show={show} onHide={onClose} centered size="md">
            <Modal.Header closeButton className="py-2 card-header-red text-white">
                <Modal.Title className="fs-6 fw-bold">
                    🔍 Selecione o Produto ({produtos.length})
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-2" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <div className="list-group">
                    {produtos.map((itemRaw, idx) => {
                        const item = normalizarProduto(itemRaw);
                        const eanItem = item.ean || "N/A";
                        const menorPrecoFloresta = item.preco_loja;

                        return (
                            <button
                                key={idx}
                                type="button"
                                className="list-group-item list-group-item-action p-2 text-start"
                                onClick={() => onSelect(item)}
                            >
                                <div className="fw-bold text-dark mb-1">{item.descricao}</div>
                                <div className="row g-1 text-muted extra-small">
                                    <div className="col-6">
                                        <span>Cód: <strong>{item.codigo}</strong> | Emb: <strong>{item.emb || 'UN'}</strong></span>
                                    </div>
                                    <div className="col-6 text-end">
                                        <span>Preço Floresta: <strong className="text-danger">{formatarMoeda(menorPrecoFloresta)}</strong></span>
                                    </div>
                                    <div className="col-12 mt-1">
                                        <span>EAN Principal: <strong>{eanItem}</strong></span>
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default function PesquisaPrecoGestao() {
    const navigate = useNavigate();
    const [loja, setLoja] = useState('0');
    const [statusFiltro, setStatusFiltro] = useState('TODOS');
    const [lojasLista, setLojasLista] = useState([]);
    const [concorrentes, setConcorrentes] = useState([]);
    const [pesquisas, setPesquisas] = useState([]);
    const [loading, setLoading] = useState(false);

    const [paginaAtual, setPaginaAtual] = useState(1);
    const ITENS_POR_PAGINA = 30;

    const [showModalConcorrente, setShowModalConcorrente] = useState(false);
    const [showModalNovaPesquisa, setShowModalNovaPesquisa] = useState(false);
    
    /* Estados para Copiar Pesquisa */
    const [showModalCopiarPesquisa, setShowModalCopiarPesquisa] = useState(false);
    const [pesquisaOrigemCopiarId, setPesquisaOrigemCopiarId] = useState('');
    
    /* Visão de Página Inteira para o Dashboard */
    const [pesquisaAtivaId, setPesquisaAtivaId] = useState(null);
    const [dashboardDados, setDashboardDados] = useState(null);

    const [concCodigo, setConcCodigo] = useState(0);
    const [concNome, setConcNome] = useState('');
    const [concLojasSel, setConcLojasSel] = useState([]);

    const [pesqDescricao, setPesqDescricao] = useState('');
    const [pesqTipo, setPesqTipo] = useState('L');
    const [pesqPermiteSimilar, setPesqPermiteSimilar] = useState(false);
    const [pesqConcorrentesSel, setPesqConcorrentesSel] = useState([]);
    const [pesqDtInicio, setPesqDtInicio] = useState(() => new Date().toISOString().split('T')[0]);
    const [pesqDtFim, setPesqDtFim] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() + 3);
        return d.toISOString().split('T')[0];
    });

    const [buscaEanProd, setBuscaEanProd] = useState('');
    const [listaProdutosPesquisa, setListaProdutosPesquisa] = useState([]);
    const [listaProdutosBusca, setListaProdutosBusca] = useState([]);
    const [showListaModal, setShowListaModal] = useState(false);

    const fileInputRef = useRef(null);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const formatarDataBR = (dataStr) => {
        if (!dataStr) return '-';
        const apenasData = String(dataStr).split('T')[0];
        const partes = apenasData.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return dataStr;
    };

    useEffect(() => {
        const isSapAdmin = localStorage.getItem("SAPADM") === "S";
        const isDiretor = localStorage.getItem("diretor") === "S";
        const isRegional = localStorage.getItem("permiteRegional") === "S";

        if (!isSapAdmin && !isDiretor && !isRegional) {
            Swal.fire({
                title: "Acesso Negado",
                text: "Você não possui permissão para acessar o Dashboard de Pesquisa de Preços.",
                icon: "error",
                confirmButtonColor: "#991b1b"
            }).then(() => {
                navigate("/arbor/home");
            });
        }
    }, [navigate]);

    const carregarLojas = useCallback(async () => {
        try {
            const res = await api.get('/lojas/localizacao');
            if (Array.isArray(res.data) && res.data.length > 0) {
                setLojasLista(res.data);
            }
        } catch (err) {
            setLojasLista([
                { codigo: 1, nome: 'Loja 01' },
                { codigo: 2, nome: 'Loja 02' },
                { codigo: 5, nome: 'Loja 05' },
                { codigo: 7, nome: 'Loja 07' },
                { codigo: 10, nome: 'Loja 10' }
            ]);
        }
    }, []);

    const carregarConcorrentes = useCallback(async () => {
        try {
            const res = await api.get('/SAP/pesquisa/concorrente');
            setConcorrentes(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error("Erro ao carregar concorrentes", err);
        }
    }, []);

    const carregarPesquisas = useCallback(async () => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams();
            if (loja !== '0') queryParams.append('loja', loja);
            if (statusFiltro !== 'TODOS') queryParams.append('status', statusFiltro);

            const url = `/SAP/pesquisa/lista${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            const res = await api.get(url);

            setPesquisas(Array.isArray(res.data) ? res.data : []);
            setPaginaAtual(1);
        } catch (err) {
            console.error("Erro ao carregar pesquisas", err);
        } finally {
            setLoading(false);
        }
    }, [loja, statusFiltro]);

    useEffect(() => {
        carregarLojas();
        carregarConcorrentes();
    }, [carregarLojas, carregarConcorrentes]);

    useEffect(() => {
        carregarPesquisas();
    }, [carregarPesquisas]);

    const pesquisasPaginadas = useMemo(() => {
        const inicio = (paginaAtual - 1) * ITENS_POR_PAGINA;
        return pesquisas.slice(inicio, inicio + ITENS_POR_PAGINA);
    }, [pesquisas, paginaAtual]);

    const totalPaginas = Math.ceil(pesquisas.length / ITENS_POR_PAGINA);

    const handleCopiarLinkColeta = (pesqLoja, pesqId) => {
        const lojaFormatada = String(pesqLoja).padStart(2, '0');
        const urlLink = `https://www.florestasm.com.br/arbor/produto/pesquisa/coleta?loja=${lojaFormatada}&pesquisa=${pesqId}`;

        navigator.clipboard.writeText(urlLink).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'Link Copiado!',
                text: 'O link direto de coleta foi copiado para a área de transferência.',
                confirmButtonColor: '#991b1b',
                timer: 2500,
                showConfirmButton: false
            });
        });
    };

    const handleSalvarConcorrente = async () => {
        if (!concNome || concLojasSel.length === 0) {
            Swal.fire("Atenção", "Preencha o nome do concorrente e selecione ao menos uma loja associada.", "warning");
            return;
        }

        try {
            setLoading(true);
            await api.post('/SAP/pesquisa/concorrente', {
                conc_codigo: concCodigo,
                conc_nome: concNome,
                conc_lojas: concLojasSel.join(',')
            });
            Swal.fire("Sucesso", "Concorrente salvo com sucesso!", "success");
            setShowModalConcorrente(false);
            carregarConcorrentes();
        } catch (err) {
            Swal.fire("Erro", "Falha ao salvar concorrente.", "error");
        } finally {
            setLoading(false);
        }
    };

    const adicionarItemUnicoNaLista = (prodRaw) => {
        const prod = normalizarProduto(prodRaw);
        const jaExiste = listaProdutosPesquisa.some(p => p.codigo === prod.codigo);
        if (jaExiste) {
            return false;
        }

        const novoItem = {
            codigo: prod.codigo,
            ean: prod.ean || '',
            descricao: prod.descricao,
            emb: prod.emb || 'UN',
            custo_loja: prod.custo_loja,
            precobasenormal: prod.precobasenormal,
            promovarejo: prod.promovarejo,
            promoapp: prod.promoapp,
            preco_loja: prod.preco_loja,
            secao: prod.secao,
            grupo: prod.grupo
        };

        setListaProdutosPesquisa(prev => [...prev, novoItem]);
        return true;
    };

    const handleAdicionarProdutoLista = async (termo = buscaEanProd) => {
        if (!termo) return;
        try {
            setLoading(true);
            const lojaConsulta = loja === '0' ? '1' : loja;
            const url = `AUDIT/produto?loja=${lojaConsulta}&pesquisa=${encodeURIComponent(termo.trim())}`;

            const res = await api.get(url);
            const data = Array.isArray(res.data) ? res.data : [];

            if (data.length === 0) {
                Swal.fire("Aviso", "Nenhum produto encontrado.", "warning");
                return;
            }

            const prodsUnicos = data.filter((item, index, self) => {
                const norm1 = normalizarProduto(item);
                return index === self.findIndex((p) => normalizarProduto(p).codigo === norm1.codigo);
            });

            if (prodsUnicos.length > 1) {
                setListaProdutosBusca(prodsUnicos);
                setShowListaModal(true);
            } else {
                const ok = adicionarItemUnicoNaLista(prodsUnicos[0]);
                if (!ok) Swal.fire("Atenção", "Produto já adicionado na lista.", "warning");
                setBuscaEanProd('');
            }
        } catch (err) {
            Swal.fire("Erro", "Falha ao buscar produto na auditoria.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleCopiarPesquisaSelecionada = async () => {
        if (!pesquisaOrigemCopiarId) {
            Swal.fire("Atenção", "Selecione uma pesquisa de origem para copiar.", "warning");
            return;
        }

        try {
            setLoading(true);
            const res = await api.get(`/SAP/pesquisa/dashboard/${pesquisaOrigemCopiarId}`);
            const itensOrigem = res.data?.itens || [];

            if (itensOrigem.length === 0) {
                Swal.fire("Aviso", "A pesquisa selecionada não possui produtos.", "warning");
                return;
            }

            const mapaUnicos = {};
            itensOrigem.forEach(it => {
                const norm = normalizarProduto(it);
                if (norm.codigo > 0 && !mapaUnicos[norm.codigo]) {
                    mapaUnicos[norm.codigo] = {
                        codigo: norm.codigo,
                        ean: norm.ean,
                        descricao: norm.descricao,
                        emb: norm.emb,
                        custo_loja: norm.custo_loja,
                        precobasenormal: norm.precobasenormal,
                        promovarejo: norm.promovarejo,
                        promoapp: norm.promoapp,
                        preco_loja: norm.preco_loja,
                        secao: norm.secao,
                        grupo: norm.grupo
                    };
                }
            });

            const novosItens = Object.values(mapaUnicos);
            setListaProdutosPesquisa(novosItens);
            setShowModalCopiarPesquisa(false);
            Swal.fire("Sucesso", `${novosItens.length} produtos copiados com sucesso para a nova pesquisa!`, "success");
        } catch (err) {
            Swal.fire("Erro", "Falha ao copiar produtos da pesquisa selecionada.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleImportarArquivo = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        const lojaConsulta = loja === '0' ? '1' : loja;
        let codigosEans = [];

        try {
            const extension = file.name.split('.').pop().toLowerCase();

            if (extension === 'xlsx' || extension === 'xls') {
                const data = await file.arrayBuffer();
                const workbook = XLSX.read(data);
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

                jsonData.forEach(row => {
                    if (row && row.length > 0) {
                        const val = String(row[0]).trim();
                        if (val && !isNaN(val)) codigosEans.push(val);
                    }
                });
            } else {
                const text = await file.text();
                const linhas = text.split(/\r?\n/);
                linhas.forEach(l => {
                    const limpo = l.split(/[,;\t]/)[0].trim();
                    if (limpo && !isNaN(limpo)) codigosEans.push(limpo);
                });
            }

            codigosEans = [...new Set(codigosEans)];

            if (codigosEans.length === 0) {
                Swal.fire("Aviso", "Nenhum código ou EAN válido encontrado no arquivo.", "warning");
                return;
            }

            let adicionados = 0;
            let logErros = [];

            for (const cod of codigosEans) {
                try {
                    const url = `AUDIT/produto?loja=${lojaConsulta}&pesquisa=${encodeURIComponent(cod)}`;
                    const res = await api.get(url);
                    const data = Array.isArray(res.data) ? res.data : [];

                    if (data.length > 0) {
                        const ok = adicionarItemUnicoNaLista(data[0]);
                        if (ok) adicionados++;
                        else logErros.push({ codigo: cod, motivo: "Produto duplicado na lista" });
                    } else {
                        logErros.push({ codigo: cod, motivo: "Código não encontrado na base/auditoria" });
                    }
                } catch (err) {
                    logErros.push({ codigo: cod, motivo: err.message || "Erro de requisição" });
                }
            }

            if (logErros.length > 0) {
                let htmlLog = `<div style="max-height:200px;overflow-y:auto;text-align:left;"><ul class="small mb-0">`;
                logErros.forEach(e => {
                    htmlLog += `<li><strong>Item ${e.codigo}:</strong> ${e.motivo}</li>`;
                });
                htmlLog += `</ul></div>`;

                Swal.fire({
                    icon: 'warning',
                    title: `Importado com Alertas (${adicionados} sucessos, ${logErros.length} falhas)`,
                    html: htmlLog,
                    confirmButtonColor: '#991b1b'
                });
            } else {
                Swal.fire("Sucesso", `Foram importados <strong>${adicionados}</strong> produtos com sucesso.`, "success");
            }

        } catch (err) {
            Swal.fire("Erro", "Falha ao processar arquivo de importação.", "error");
        } finally {
            setLoading(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    const handleSalvarNovaPesquisa = async () => {
        if (!pesqDescricao || pesqConcorrentesSel.length === 0) {
            Swal.fire("Atenção", "Preencha a descrição e selecione ao menos um concorrente.", "warning");
            return;
        }

        if (pesqTipo === 'L' && listaProdutosPesquisa.length === 0) {
            Swal.fire("Atenção", "Para pesquisas do tipo Lista, inclua ao menos um produto.", "warning");
            return;
        }

        try {
            setLoading(true);

            const produtosParaEnvio = pesqTipo === 'L'
                ? listaProdutosPesquisa.flatMap(prod =>
                    pesqConcorrentesSel.map(concId => ({
                        ...prod,
                        conc_codigo: Number(concId)
                    }))
                )
                : [];

            await api.post('/SAP/pesquisa/abrir', {
                pesq_loja: Number(loja === '0' ? '1' : loja),
                pesq_descricao: pesqDescricao,
                pesq_tipo: pesqTipo,
                pesq_permite_similar: pesqPermiteSimilar ? 'S' : 'N',
                pesq_concorrentes: pesqConcorrentesSel.join(','),
                pesq_dtinicio: pesqDtInicio,
                pesq_dtfim: pesqDtFim,
                produtos: produtosParaEnvio
            });

            Swal.fire("Sucesso", "Pesquisa de Preço aberta com sucesso!", "success");
            setShowModalNovaPesquisa(false);
            carregarPesquisas();
        } catch (err) {
            Swal.fire("Erro", "Falha ao abrir pesquisa de preço.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizarColetaPesquisa = async (pesqId) => {
        const confirm = await Swal.fire({
            title: "Encerrar Coleta?",
            text: "A pesquisa deixará de aparecer no aplicativo de coleta. Deseja prosseguir para a etapa de análise?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#991b1b",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, Finalizar Coleta",
            cancelButtonText: "Cancelar"
        });

        if (confirm.isConfirmed) {
            try {
                setLoading(true);
                await api.post('/SAP/pesquisa/status', { pesq_id: Number(pesqId), status: 'F' });
                Swal.fire("Coleta Encerrada", "A pesquisa agora está pronta para análise e aprovação de preços.", "success");
                carregarPesquisas();
            } catch (err) {
                Swal.fire("Erro", "Falha ao encerrar coleta da pesquisa.", "error");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleConcluirAnalisePrecos = async (pesqId) => {
        const confirm = await Swal.fire({
            title: "Concluir Análise e Reajustar?",
            text: "Após concluir a análise, os preços a acompanhar serão consolidados e não poderão mais ser editados.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#198754",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, Concluir Análise",
            cancelButtonText: "Cancelar"
        });

        if (confirm.isConfirmed) {
            try {
                setLoading(true);
                await api.post('/SAP/pesquisa/status', { pesq_id: Number(pesqId), status: 'C' });
                Swal.fire("Análise Concluída", "Os preços foram consolidados com sucesso!", "success");
                handleAbrirDashboard(pesqId);
                carregarPesquisas();
            } catch (err) {
                Swal.fire("Erro", "Falha ao concluir análise da pesquisa.", "error");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleAbrirDashboard = async (pesqId) => {
        try {
            setLoading(true);
            const res = await api.get(`/SAP/pesquisa/dashboard/${pesqId}`);
            setDashboardDados(res.data);
            setPesquisaAtivaId(pesqId);
        } catch (err) {
            Swal.fire("Erro", "Falha ao carregar dashboard da pesquisa.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleSalvarPrecoAcompanhar = async (item, novoPreco) => {
        try {
            const pprodId = item.pprod_id ?? item.PPROD_ID;
            await api.post('/SAP/pesquisa/atualizar-preco', {
                pprod_id: pprodId,
                preco_acompanhar: parseFloat(novoPreco)
            });
        } catch (err) {
            console.error("Erro ao atualizar preço a acompanhar", err);
        }
    };

    const handleExportarExcel = () => {
        if (!dashboardDados || !dashboardDados.itens) return;
        const listaConcorrentes = dashboardDados.concorrentes || [];
        
        const mapaExport = {};
        (dashboardDados.itens || []).forEach(it => {
            const cod = it.pprod_codigo ?? it.PPROD_CODIGO;
            if (!mapaExport[cod]) {
                mapaExport[cod] = {
                    "Cód. Produto": cod,
                    "EAN": it.pprod_ean ?? it.PPROD_EAN,
                    "Descrição": it.pprod_descricao ?? it.PPROD_DESCRICAO,
                    "Preço Reg. Floresta": it.pprod_preco_reg_loja ?? 0,
                    "Preço Promo Floresta": it.pprod_preco_promo_loja ?? 0,
                    "Custo Loja": it.pprod_custo_loja ?? 0,
                    "Preço Acompanhar": it.pprod_preco_acompanhar ?? 0
                };
            }
            const concId = it.conc_codigo ?? it.CONC_CODIGO;
            const concObj = listaConcorrentes.find(c => (c.conc_codigo ?? c.CONC_CODIGO) === concId);
            const nomeConc = concObj ? (concObj.conc_nome ?? concObj.CONC_NOME) : `Conc. ${concId}`;

            const valReg = it.pprod_preco_conc ?? 0;
            const valPromo = it.pprod_preco_promo_conc ?? 0;

            mapaExport[cod][`${nomeConc} (Regular)`] = valReg === 0.01 ? "Não Encontrado" : valReg;
            if (valPromo > 0) {
                mapaExport[cod][`${nomeConc} (Promoção)`] = valPromo;
            }
        });

        const dadosExportacao = Object.values(mapaExport);

        const worksheet = XLSX.utils.json_to_sheet(dadosExportacao);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard Pesquisa");
        XLSX.writeFile(workbook, `Pesquisa_Preco_${dashboardDados?.cabecalho?.pesq_id || 'relatorio'}.xlsx`);
    };

    return (
        <div className="bg-light min-vh-100 d-flex flex-column">
            <style>{`
                .btn-custom-red { background-color: #991b1b !important; border-color: #991b1b !important; color: #fff !important; }
                .btn-custom-red:hover { background-color: #7f1d1d !important; border-color: #7f1d1d !important; }
                .card-header-red { background-color: #991b1b !important; color: #fff !important; }
                
                .menor-preco-moldura { 
                    border: 2px solid #198754 !important; 
                    background-color: #f0fdf4 !important;
                    border-radius: 6px; 
                    padding: 3px 5px; 
                    box-shadow: 0 0 0 1px #198754; 
                }
                .badge-margem { font-size: 0.65rem; padding: 1px 4px; border-radius: 3px; display: inline-block; margin-top: 2px; }
                
                .table-sticky-container {
                    max-height: calc(100vh - 210px);
                    overflow-y: auto;
                    position: relative;
                }
                .table-sticky-header th { 
                    position: sticky; 
                    top: 0; 
                    z-index: 1020; 
                    text-align: center; 
                    vertical-align: middle;
                    background-color: #212529 !important;
                    color: #fff !important;
                }
            `}</style>

            <Menu modulo="ARBOR" />

            <Modal show={loading} centered backdrop="static" keyboard={false} size="sm">
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" style={{ color: '#991b1b' }} className="mb-2" />
                    <div className="fw-bold text-dark">Processando...</div>
                </Modal.Body>
            </Modal>

            {pesquisaAtivaId ? (
                <div className="container-fluid p-2" style={{ marginTop: '70px', backgroundColor: '#f8f9fa' }}>
                    <div className="card shadow-sm border-0 mb-2">
                        <div className="card-body py-2 px-3">
                            {(() => {
                                const cab = dashboardDados?.cabecalho || {};
                                const pesqId = cab.pesq_id ?? cab.PESQ_ID;
                                const statusPesq = cab.pesq_status ?? cab.PESQ_STATUS;
                                const isConcluida = statusPesq === 'C';

                                return (
                                    <div className="row align-items-center g-2">
                                        <div className="col-md-3 d-flex align-items-center">
                                            <span className="fw-bold text-dark fs-6 text-truncate">
                                                <FaCalculator className="me-1 text-danger" /> Pesquisa #{pesqId}
                                            </span>
                                        </div>

                                        <div className="col-md-5 text-muted extra-small d-flex justify-content-center gap-3 flex-wrap">
                                            <span><strong>Desc:</strong> {cab.pesq_descricao ?? cab.PESQ_DESCRICAO}</span>
                                            <span><strong>Loja:</strong> {String(cab.pesq_loja ?? cab.PESQ_LOJA).padStart(2, '0')}</span>
                                            <span><strong>Vigência:</strong> {formatarDataBR(cab.dt_inicio ?? cab.DT_INICIO)} a {formatarDataBR(cab.dt_fim ?? cab.DT_FIM)}</span>
                                        </div>

                                        <div className="col-md-4 text-end d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                            <Button 
                                                size="sm" 
                                                variant="danger" 
                                                className="fw-bold py-1 px-2 shadow-sm d-flex align-items-center gap-1 extra-small"
                                                onClick={() => setPesquisaAtivaId(null)}
                                            >
                                                <FaArrowLeft /> Voltar
                                            </Button>
                                            <Button size="sm" variant="success" className="fw-bold py-1 px-2 text-white shadow-sm extra-small" onClick={handleExportarExcel}>
                                                <FaFileExcel className="me-1" /> Excel
                                            </Button>
                                            {isConcluida ? (
                                                <Badge bg="secondary" className="fs-7 p-2 d-flex align-items-center"><FaLock className="me-1" /> Concluída</Badge>
                                            ) : (
                                                <Button size="sm" variant="success" className="fw-bold py-1 px-2 extra-small text-nowrap" onClick={() => handleConcluirAnalisePrecos(pesqId)}>
                                                    <FaCheck className="me-1" /> Fixar Preços
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>

                    <div className="card shadow-sm border-0">
                        <div className="card-body p-2">
                            {(() => {
                                const listaConcorrentes = dashboardDados?.concorrentes || [];

                                const mapaProdutos = {};
                                (dashboardDados?.itens || []).forEach(it => {
                                    const cod = it.pprod_codigo ?? it.PPROD_CODIGO;
                                    const concId = it.conc_codigo ?? it.CONC_CODIGO;

                                    if (!mapaProdutos[cod]) {
                                        mapaProdutos[cod] = {
                                            codigo: cod,
                                            ean: it.pprod_ean ?? it.PPROD_EAN,
                                            descricao: it.pprod_descricao ?? it.PPROD_DESCRICAO,
                                            emb: it.pprod_emb ?? it.PPROD_EMB ?? 'UN',
                                            secao: it.pprod_secao ?? it.PPROD_SECAO ?? 0,
                                            grupo: it.pprod_grupo ?? it.PPROD_GRUPO ?? 0,
                                            precoRegLoja: it.pprod_preco_reg_loja ?? it.precobasenormal ?? it.pprod_preco_loja ?? 0,
                                            precoPromoLoja: it.pprod_preco_promo_loja ?? it.promovarejo ?? 0,
                                            precoLoja: it.pprod_preco_loja ?? it.PPROD_PRECO_LOJA ?? 0,
                                            custoLoja: it.pprod_custo_loja ?? it.PPROD_CUSTO_LOJA ?? 0,
                                            precoAcompanhar: it.pprod_preco_acompanhar ?? it.PPROD_PRECO_ACOMPANHAR ?? 0,
                                            itemRef: it,
                                            precosConcorrentes: {}
                                        };
                                    }

                                    mapaProdutos[cod].precosConcorrentes[concId] = {
                                        pprod_id: it.pprod_id ?? it.PPROD_ID,
                                        preco: it.pprod_preco_conc ?? it.PPROD_PRECO_CONC ?? 0,
                                        precoPromo: it.pprod_preco_promo_conc ?? it.PPROD_PRECO_PROMO_CONC ?? 0,
                                        isSimilar: (it.pprod_is_similar ?? it.PPROD_IS_SIMILAR) === 'S',
                                        similarNome: it.pprod_similar_nome ?? it.PPROD_SIMILAR_NOME ?? '',
                                        similarEan: it.pprod_similar_ean ?? it.PPROD_SIMILAR_EAN ?? 0
                                    };
                                });

                                const produtosAgrupados = Object.values(mapaProdutos).sort((a, b) => {
                                    if (a.secao !== b.secao) return a.secao - b.secao;
                                    if (a.grupo !== b.grupo) return a.grupo - b.grupo;
                                    return a.descricao.localeCompare(b.descricao);
                                });

                                produtosAgrupados.forEach(prod => {
                                    const precosValidos = [
                                        prod.precoRegLoja, 
                                        prod.precoPromoLoja, 
                                        ...Object.values(prod.precosConcorrentes).flatMap(p => [p.preco, p.precoPromo])
                                    ].filter(p => p > 0 && p !== 0.01);
                                    
                                    prod.menorPrecoGeral = precosValidos.length > 0 ? Math.min(...precosValidos) : 0;
                                });

                                const cab = dashboardDados?.cabecalho || {};
                                const statusPesq = cab.pesq_status ?? cab.PESQ_STATUS;
                                const isConcluida = statusPesq === 'C';

                                return (
                                    <div className="table-responsive table-sticky-container border bg-white rounded shadow-sm">
                                        <Table size="sm" bordered hover className="align-middle text-center mb-0 w-100 table-sticky-header" style={{ fontSize: '0.8rem' }}>
                                            <thead>
                                                <tr>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '45px' }}>Foto</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '55px' }}>Cód.</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ minWidth: '220px' }}>Descrição Produto</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '90px' }}>Preço Reg. Floresta</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '90px' }}>Preço Promo Floresta</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '80px' }}>Custo</th>

                                                    {listaConcorrentes.map((c, idxColor) => {
                                                        const cId = c.conc_codigo ?? c.CONC_CODIGO;
                                                        const cNome = c.conc_nome ?? c.CONC_NOME;
                                                        const corEstilo = CORES_CONCORRENTES[idxColor % CORES_CONCORRENTES.length];

                                                        return (
                                                            <th 
                                                                key={cId} 
                                                                className="align-middle text-center text-truncate" 
                                                                style={{ 
                                                                    minWidth: '130px', 
                                                                    backgroundColor: corEstilo.headerBg, 
                                                                    color: corEstilo.headerText 
                                                                }} 
                                                                title={cNome}
                                                            >
                                                                {cNome}
                                                            </th>
                                                        );
                                                    })}

                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '120px' }}>% Menor Conc. vs Floresta</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '90px' }}>Preço Acom.</th>
                                                    <th className="align-middle text-center bg-dark text-white" style={{ width: '80px' }}>Margem (%)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {produtosAgrupados.map((prod) => {
                                                    const pFloresta = prod.precoLoja > 0 ? prod.precoLoja : (prod.precoRegLoja || 0);
                                                    const custo = prod.custoLoja;

                                                    const precosValidosConc = Object.values(prod.precosConcorrentes)
                                                        .map(p => p.preco)
                                                        .filter(p => p > 0 && p !== 0.01);

                                                    const menorPrecoConc = precosValidosConc.length > 0 ? Math.min(...precosValidosConc) : 0;
                                                    const pAcompanhar = prod.precoAcompanhar > 0 ? prod.precoAcompanhar : menorPrecoConc;

                                                    const difPerc = (menorPrecoConc > 0 && pFloresta > 0)
                                                        ? ((pFloresta - menorPrecoConc) / menorPrecoConc) * 100
                                                        : 0;

                                                    const margemAcompanhar = pAcompanhar > 0 ? calcularMargem(pAcompanhar, custo) : null;

                                                    const isRegFlorestaMaisBarato = prod.precoRegLoja > 0 && prod.precoRegLoja === prod.menorPrecoGeral;
                                                    const isPromoFlorestaMaisBarato = prod.precoPromoLoja > 0 && prod.precoPromoLoja === prod.menorPrecoGeral;

                                                    const mRegFloresta = prod.precoRegLoja > 0 ? calcularMargem(prod.precoRegLoja, custo) : null;
                                                    const mPromoFloresta = prod.precoPromoLoja > 0 ? calcularMargem(prod.precoPromoLoja, custo) : null;

                                                    return (
                                                        <tr key={prod.codigo}>
                                                            <td className="p-1 align-middle text-center">
                                                                <div 
                                                                    style={{ cursor: 'pointer', display: 'inline-block' }} 
                                                                    onClick={() => setFotoSelecionada({
                                                                        foto: `https://cdn-cosmos.bluesoft.com.br/products/${prod.ean}`,
                                                                        nome: prod.descricao,
                                                                        info01: `Cód: ${prod.codigo} | EAN: ${prod.ean}`,
                                                                        info02: `Reg. Floresta: ${formatarMoeda(prod.precoRegLoja)}`
                                                                    })}
                                                                >
                                                                    <img
                                                                        src={`https://cdn-cosmos.bluesoft.com.br/products/${prod.ean}`}
                                                                        alt="Prod"
                                                                        style={{ width: '32px', height: '32px', objectFit: 'contain' }}
                                                                        onError={e => e.target.src = "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="fw-bold p-1 align-middle text-center">{prod.codigo}</td>
                                                            <td className="text-start fw-bold p-1 text-wrap align-middle" style={{ minWidth: '220px' }}>{prod.descricao}</td>

                                                            <td className="p-1 align-middle text-center">
                                                                <div className={`p-1 rounded ${isRegFlorestaMaisBarato ? 'menor-preco-moldura fw-bold' : ''}`}>
                                                                    <span className={isRegFlorestaMaisBarato ? "text-success fw-bold" : "text-dark"}>
                                                                        {formatarMoeda(prod.precoRegLoja)}
                                                                    </span>
                                                                    {mRegFloresta !== null && (
                                                                        <div><span className="badge-margem bg-light text-muted border">m: {mRegFloresta.toFixed(1)}%</span></div>
                                                                    )}
                                                                </div>
                                                            </td>

                                                            <td className="p-1 align-middle text-center">
                                                                {prod.precoPromoLoja > 0 ? (
                                                                    <div className={`p-1 rounded ${isPromoFlorestaMaisBarato ? 'menor-preco-moldura fw-bold' : ''}`}>
                                                                        <span className={isPromoFlorestaMaisBarato ? "text-success fw-bold" : "text-success"}>
                                                                            {formatarMoeda(prod.precoPromoLoja)}
                                                                        </span>
                                                                        {mPromoFloresta !== null && (
                                                                            <div><span className="badge-margem bg-light text-muted border">m: {mPromoFloresta.toFixed(1)}%</span></div>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>

                                                            <td className="text-muted p-1 align-middle text-center">{formatarMoeda(custo)}</td>

                                                            {listaConcorrentes.map((c) => {
                                                                const cId = c.conc_codigo ?? c.CONC_CODIGO;
                                                                const dadosConc = prod.precosConcorrentes[cId];
                                                                const valorConc = dadosConc ? dadosConc.preco : 0;
                                                                const valorPromoConc = dadosConc ? dadosConc.precoPromo : 0;
                                                                const isSim = dadosConc ? dadosConc.isSimilar : false;

                                                                const naoEncontrado = valorConc === 0.01;

                                                                const isRegConcMaisBarato = !naoEncontrado && valorConc > 0 && prod.menorPrecoGeral > 0 && valorConc === prod.menorPrecoGeral;
                                                                const isPromoConcMaisBarato = !naoEncontrado && valorPromoConc > 0 && prod.menorPrecoGeral > 0 && valorPromoConc === prod.menorPrecoGeral;

                                                                const mConc = (!naoEncontrado && valorConc > 0) ? calcularMargem(valorConc, custo) : null;
                                                                const mPromoConc = (!naoEncontrado && valorPromoConc > 0) ? calcularMargem(valorPromoConc, custo) : null;

                                                                return (
                                                                    <td key={cId} className="p-1 align-middle text-center bg-white">
                                                                        {naoEncontrado ? (
                                                                            <Badge bg="secondary" className="fs-8 py-1 px-2">Não Encontrado</Badge>
                                                                        ) : valorConc > 0 ? (
                                                                            <div>
                                                                                <div className={`p-1 rounded mb-1 ${isRegConcMaisBarato ? 'menor-preco-moldura fw-bold' : 'border bg-light'}`}>
                                                                                    <div className="text-danger" style={{ fontSize: '0.75rem' }}>
                                                                                        Reg: {formatarMoeda(valorConc)}
                                                                                    </div>
                                                                                    {mConc !== null && (
                                                                                        <span className="badge-margem bg-white text-muted border">
                                                                                            m: {mConc.toFixed(1)}%
                                                                                        </span>
                                                                                    )}
                                                                                </div>

                                                                                {valorPromoConc > 0 && (
                                                                                    <div className={`p-1 rounded ${isPromoConcMaisBarato ? 'menor-preco-moldura fw-bold' : 'border bg-light'}`}>
                                                                                        <div className="text-success" style={{ fontSize: '0.75rem' }}>
                                                                                            Promo: {formatarMoeda(valorPromoConc)}
                                                                                        </div>
                                                                                        {mPromoConc !== null && (
                                                                                            <span className="badge-margem bg-white text-muted border">
                                                                                                m: {mPromoConc.toFixed(1)}%
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                                {isSim && (
                                                                                    <div className="mt-1">
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="warning"
                                                                                            className="extra-small py-0 px-1 border-0 fw-bold"
                                                                                            style={{ fontSize: '0.65rem' }}
                                                                                            onClick={() => {
                                                                                                setFotoSelecionada({
                                                                                                    foto: `https://cdn-cosmos.bluesoft.com.br/products/${dadosConc.similarEan}`,
                                                                                                    nome: dadosConc.similarNome,
                                                                                                    info01: `EAN Similar: ${dadosConc.similarEan}`,
                                                                                                    info02: 'Produto Similar Coletado'
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            ⚠️ Similar
                                                                                        </Button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <span className="text-muted fw-normal">-</span>
                                                                        )}
                                                                    </td>
                                                                );
                                                            })}

                                                            <td className="p-1 align-middle text-center">
                                                                {menorPrecoConc > 0 ? (
                                                                    <Badge bg={difPerc > 0 ? "danger" : (difPerc < 0 ? "success" : "secondary")} style={{ fontSize: '0.68rem', padding: '3px 5px' }}>
                                                                        {difPerc > 0 ? `+${difPerc.toFixed(1)}%` : `${difPerc.toFixed(1)}%`}
                                                                    </Badge>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>

                                                            <td className="p-1 align-middle text-center">
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    disabled={isConcluida}
                                                                    className={`text-center p-0 px-1 fw-bold ${isConcluida ? 'bg-light text-muted' : ''}`}
                                                                    style={{ width: '85px', height: '26px', fontSize: '0.78rem', margin: '0 auto' }}
                                                                    defaultValue={pAcompanhar > 0 ? formatarApenasNumero(pAcompanhar) : ''}
                                                                    onFocus={(e) => {
                                                                        const num = parseCurrencyToNumber(pAcompanhar);
                                                                        e.target.value = num > 0 ? num.toFixed(2).replace('.', ',') : '';
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        if (!isConcluida) {
                                                                            const valNum = parseCurrencyToNumber(e.target.value);
                                                                            handleSalvarPrecoAcompanhar(prod.itemRef, valNum);
                                                                            e.target.value = valNum > 0 ? formatarApenasNumero(valNum) : '';
                                                                        }
                                                                    }}
                                                                />
                                                            </td>

                                                            <td className={`fw-bold p-1 align-middle text-center ${margemAcompanhar !== null && margemAcompanhar < 15 ? "text-danger" : "text-success"}`}>
                                                                {margemAcompanhar !== null ? `${margemAcompanhar.toFixed(1)}%` : '-'}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            ) : (
                <main className="container-fluid" style={{ paddingTop: '95px' }}>
                    <Tabs defaultActiveKey="pesquisas" className="mb-3">
                        <Tab eventKey="pesquisas" title="Pesquisas de Preço">
                            <div className="card shadow-sm border-0 mb-3">
                                <div className="card-body py-2">
                                    <div className="row align-items-end g-2">
                                        <div className="col-md-3">
                                            <Form.Label className="small fw-bold mb-1">Loja de Origem</Form.Label>
                                            <Form.Select value={loja} onChange={e => setLoja(e.target.value)}>
                                                <option value="0">Todas as Lojas</option>
                                                {lojasLista.map(lj => {
                                                    const valLoja = lj.codigo ?? lj.cod_emp ?? '';
                                                    const codStr = String(valLoja).padStart(2, '0');
                                                    return (
                                                        <option key={valLoja} value={valLoja}>
                                                            {lj.nome || lj.razao || `Loja ${codStr}`}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </div>

                                        <div className="col-md-3">
                                            <Form.Label className="small fw-bold mb-1">Status da Pesquisa</Form.Label>
                                            <Form.Select value={statusFiltro} onChange={e => setStatusFiltro(e.target.value)}>
                                                <option value="TODOS">Todos os Status</option>
                                                <option value="A">Em Coleta (Aberta)</option>
                                                <option value="F">Coleta Encerrada / Em Análise</option>
                                                <option value="C">Concluída / Fechada</option>
                                            </Form.Select>
                                        </div>

                                        <div className="col-md-auto ms-auto d-flex gap-2">
                                            <Button className="btn-custom-red fw-bold" onClick={() => {
                                                setPesqDescricao('');
                                                setPesqPermiteSimilar(false);
                                                setPesqConcorrentesSel([]);
                                                setListaProdutosPesquisa([]);
                                                setShowModalNovaPesquisa(true);
                                            }}>
                                                <FaPlus className="me-1" /> Abrir Pesquisa de Preço
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card shadow-sm border-0">
                                <div className="card-header card-header-red fw-bold d-flex justify-content-between align-items-center py-2">
                                    <span><FaFileAlt className="me-2" /> Painel de Pesquisas de Preços</span>
                                    <span className="extra-small fw-normal">Total: <strong>{pesquisas.length}</strong> pesquisas encontradas</span>
                                </div>
                                <div className="table-responsive">
                                    <Table hover striped className="mb-0 align-middle text-center small">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>ID</th>
                                                <th>Descrição</th>
                                                <th>Loja</th>
                                                <th>Tipo</th>
                                                <th>Permite Similar</th>
                                                <th>Vigência</th>
                                                <th>Status</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pesquisasPaginadas.length > 0 ? (
                                                pesquisasPaginadas.map(p => {
                                                    const id = p.pesq_id ?? p.PESQ_ID;
                                                    const descricao = p.pesq_descricao ?? p.PESQ_DESCRICAO;
                                                    const lojaPesq = p.pesq_loja ?? p.PESQ_LOJA;
                                                    const tipo = p.pesq_tipo ?? p.PESQ_TIPO;
                                                    const permiteSim = (p.pesq_permite_similar ?? p.PESQ_PERMITE_SIMILAR) === 'S';
                                                    const dtIni = p.dt_inicio ?? p.DT_INICIO;
                                                    const dtFim = p.dt_fim ?? p.DT_FIM;
                                                    const status = p.pesq_status ?? p.PESQ_STATUS;

                                                    const isAberta = status === 'A';
                                                    const isFinalizada = status === 'F';
                                                    const isConcluida = status === 'C';

                                                    return (
                                                        <tr key={id}>
                                                            <td className="fw-bold">{id}</td>
                                                            <td className="text-start">{descricao}</td>
                                                            <td>Loja {String(lojaPesq).padStart(2, '0')}</td>
                                                            <td>
                                                                <Badge bg={tipo === 'L' ? 'primary' : 'info'}>
                                                                    {tipo === 'L' ? 'Lista' : 'Via Coleta'}
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <Badge bg={permiteSim ? 'success' : 'secondary'}>
                                                                    {permiteSim ? 'Sim' : 'Não'}
                                                                </Badge>
                                                            </td>
                                                            <td>{formatarDataBR(dtIni)} até {formatarDataBR(dtFim)}</td>
                                                            <td>
                                                                {isAberta && <Badge bg="success">Em Coleta</Badge>}
                                                                {isFinalizada && <Badge bg="warning" text="dark">Coleta Encerrada / Em Análise</Badge>}
                                                                {isConcluida && <Badge bg="secondary"><FaLock className="me-1" /> Concluída / Fechada</Badge>}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex justify-content-center gap-1">
                                                                    {isAberta && (
                                                                        <Button
                                                                            size="sm"
                                                                            variant="outline-secondary"
                                                                            className="fw-bold"
                                                                            title="Copiar Link Direto para Coleta"
                                                                            onClick={() => handleCopiarLinkColeta(lojaPesq, id)}
                                                                        >
                                                                            <FaLink className="me-1" /> Copiar Link
                                                                        </Button>
                                                                    )}

                                                                    <Button size="sm" variant="outline-danger" className="fw-bold" onClick={() => handleAbrirDashboard(id)}>
                                                                        <FaChartBar className="me-1" /> Dashboard
                                                                    </Button>

                                                                    {isAberta && (
                                                                        <Button size="sm" variant="danger" className="fw-bold" title="Finalizar Coleta no App" onClick={() => handleFinalizarColetaPesquisa(id)}>
                                                                            <FaBan className="me-1" /> Finalizar Coleta
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-muted py-3">Nenhuma pesquisa encontrada para os filtros selecionados.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {totalPaginas > 1 && (
                                    <div className="card-footer d-flex justify-content-between align-items-center py-2 bg-white">
                                        <span className="extra-small text-muted">
                                            Exibindo {((paginaAtual - 1) * ITENS_POR_PAGINA) + 1} até {Math.min(paginaAtual * ITENS_POR_PAGINA, pesquisas.length)} de {pesquisas.length} registros
                                        </span>
                                        <Pagination size="sm" className="mb-0">
                                            <Pagination.First onClick={() => setPaginaAtual(1)} disabled={paginaAtual === 1} />
                                            <Pagination.Prev onClick={() => setPaginaAtual(prev => Math.max(prev - 1, 1))} disabled={paginaAtual === 1} />

                                            {[...Array(totalPaginas)].map((_, idx) => {
                                                const numPag = idx + 1;
                                                if (numPag === 1 || numPag === totalPaginas || (numPag >= paginaAtual - 2 && numPag <= paginaAtual + 2)) {
                                                    return (
                                                        <Pagination.Item
                                                            key={numPag}
                                                            active={numPag === paginaAtual}
                                                            onClick={() => setPaginaAtual(numPag)}
                                                        >
                                                            {numPag}
                                                        </Pagination.Item>
                                                    );
                                                }
                                                return null;
                                            })}

                                            <Pagination.Next onClick={() => setPaginaAtual(prev => Math.min(prev + 1, totalPaginas))} disabled={paginaAtual === totalPaginas} />
                                            <Pagination.Last onClick={() => setPaginaAtual(totalPaginas)} disabled={paginaAtual === totalPaginas} />
                                        </Pagination>
                                    </div>
                                )}
                            </div>
                        </Tab>

                        <Tab eventKey="concorrentes" title="Cadastro de Concorrentes">
                            <div className="card shadow-sm border-0">
                                <div className="card-header card-header-red fw-bold d-flex justify-content-between align-items-center py-2">
                                    <span><FaStore className="me-2" /> Redes / Lojas Concorrentes</span>
                                    <Button size="sm" variant="light" className="fw-bold text-danger" onClick={() => {
                                        setConcCodigo(0);
                                        setConcNome('');
                                        setConcLojasSel([]);
                                        setShowModalConcorrente(true);
                                    }}>
                                        <FaPlus className="me-1" /> Novo Concorrente
                                    </Button>
                                </div>
                                <Table hover striped className="mb-0 align-middle text-center small">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th>Código</th>
                                            <th>Nome do Concorrente</th>
                                            <th>Lojas de Atuação</th>
                                            <th>Status</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {concorrentes.map(c => {
                                            const codigo = c.conc_codigo ?? c.CONC_CODIGO;
                                            const nome = c.conc_nome ?? c.CONC_NOME;
                                            const lojasConc = c.conc_lojas ?? c.CONC_LOJAS ?? '';

                                            return (
                                                <tr key={codigo}>
                                                    <td className="fw-bold">{codigo}</td>
                                                    <td className="text-start fw-bold">{nome}</td>
                                                    <td>{lojasConc}</td>
                                                    <td><Badge bg="success">Ativo</Badge></td>
                                                    <td>
                                                        <Button size="sm" variant="outline-dark" className="py-0" onClick={() => {
                                                            setConcCodigo(codigo);
                                                            setConcNome(nome);
                                                            setConcLojasSel(lojasConc ? lojasConc.split(',') : []);
                                                            setShowModalConcorrente(true);
                                                        }}>
                                                            Editar
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        </Tab>
                    </Tabs>
                </main>
            )}

            <Modal show={showModalConcorrente} onHide={() => setShowModalConcorrente(false)} centered>
                <Modal.Header closeButton className="card-header-red py-2 text-white">
                    <Modal.Title className="fs-6 fw-bold">Cadastro de Concorrente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Nome do Concorrente</Form.Label>
                        <Form.Control type="text" placeholder="Ex: Royal, Guanabara..." value={concNome} onChange={e => setConcNome(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Associar às Lojas Floresta</Form.Label>
                        <div className="d-flex flex-wrap gap-2 border p-2 rounded">
                            {lojasLista.map(lj => {
                                const valLoja = lj.codigo ?? lj.cod_emp ?? '';
                                const codStr = String(valLoja).padStart(2, '0');
                                const isChecked = concLojasSel.includes(codStr) || concLojasSel.includes(String(valLoja));

                                return (
                                    <Form.Check
                                        key={codStr}
                                        type="checkbox"
                                        id={`conc-lj-${codStr}`}
                                        label={`Loja ${codStr}`}
                                        checked={isChecked}
                                        onChange={() => {
                                            if (isChecked) {
                                                setConcLojasSel(concLojasSel.filter(l => l !== codStr && l !== String(valLoja)));
                                            } else {
                                                setConcLojasSel([...concLojasSel, codStr]);
                                            }
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </Form.Group>
                    <div className="text-end">
                        <Button className="btn-custom-red fw-bold" onClick={handleSalvarConcorrente}>
                            <FaSave className="me-1" /> Salvar Concorrente
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showModalNovaPesquisa} onHide={() => setShowModalNovaPesquisa(false)} size="lg" centered>
                <Modal.Header closeButton className="card-header-red py-2 text-white">
                    <Modal.Title className="fs-6 fw-bold">Abrir Nova Pesquisa de Preço</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-2 mb-3">
                        <Col md={6}>
                            <Form.Label className="small fw-bold">Descrição da Pesquisa</Form.Label>
                            <Form.Control type="text" placeholder="Ex: Pesquisa Semanal de HortiFruti" value={pesqDescricao} onChange={e => setPesqDescricao(e.target.value)} />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold">Data Início</Form.Label>
                            <Form.Control type="date" value={pesqDtInicio} onChange={e => setPesqDtInicio(e.target.value)} />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold">Data Fim (Auto Fechamento)</Form.Label>
                            <Form.Control type="date" value={pesqDtFim} onChange={e => setPesqDtFim(e.target.value)} />
                        </Col>
                    </Row>

                    <Row className="g-2 mb-3">
                        <Col md={4}>
                            <Form.Label className="small fw-bold">Tipo de Pesquisa</Form.Label>
                            <Form.Select value={pesqTipo} onChange={e => setPesqTipo(e.target.value)}>
                                <option value="L">Lista de Produtos Predefinidos</option>
                                <option value="C">Via Coleta Livre no Concorrente</option>
                            </Form.Select>
                        </Col>
                        <Col md={4} className="d-flex align-items-center pt-3">
                            <Form.Check
                                type="switch"
                                id="pesq-permite-similar-switch"
                                label="Permitir Produto Similar"
                                checked={pesqPermiteSimilar}
                                onChange={e => setPesqPermiteSimilar(e.target.checked)}
                                className="fw-bold text-secondary"
                            />
                        </Col>
                        <Col md={12}>
                            <Form.Label className="small fw-bold">Selecione os Concorrentes a Pesquisar</Form.Label>
                            {(() => {
                                const lojaAtualStr = String(loja === '0' ? '1' : loja).padStart(2, '0');
                                const lojaAtualSemZero = String(Number(loja === '0' ? '1' : loja));

                                const concorrentesDaLoja = concorrentes.filter(c => {
                                    const lojasAtuacao = String(c.conc_lojas ?? c.CONC_LOJAS ?? '').split(',').map(s => s.trim());
                                    return lojasAtuacao.includes(lojaAtualStr) || lojasAtuacao.includes(lojaAtualSemZero);
                                });

                                return (
                                    <div className="d-flex flex-wrap gap-2 border p-2 rounded bg-light" style={{ maxHeight: '120px', overflowY: 'auto' }}>
                                        {concorrentesDaLoja.length > 0 ? (
                                            concorrentesDaLoja.map(c => {
                                                const cIdStr = String(c.conc_codigo ?? c.CONC_CODIGO);
                                                const cNome = c.conc_nome ?? c.CONC_NOME;
                                                const isChecked = pesqConcorrentesSel.includes(cIdStr);

                                                return (
                                                    <Form.Check
                                                        key={cIdStr}
                                                        type="checkbox"
                                                        id={`pesq-conc-${cIdStr}`}
                                                        label={cNome}
                                                        checked={isChecked}
                                                        onChange={() => {
                                                            if (isChecked) {
                                                                setPesqConcorrentesSel(pesqConcorrentesSel.filter(id => id !== cIdStr));
                                                            } else {
                                                                setPesqConcorrentesSel([...pesqConcorrentesSel, cIdStr]);
                                                            }
                                                        }}
                                                    />
                                                );
                                            })
                                        ) : (
                                            <span className="text-muted small">Nenhum concorrente cadastrado para a Loja {lojaAtualStr}.</span>
                                        )}
                                    </div>
                                );
                            })()}
                        </Col>
                    </Row>

                    {pesqTipo === 'L' && (
                        <Card className="p-2 bg-light border mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
                                <Form.Label className="small fw-bold mb-0">Adicionar Produtos na Lista (Informe EAN, Código ou Descrição)</Form.Label>

                                <div className="d-flex gap-1 flex-wrap">
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        accept=".txt,.csv,.xls,.xlsx"
                                        onChange={handleImportarArquivo}
                                    />
                                    <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="fw-bold extra-small py-0"
                                        onClick={() => setShowModalCopiarPesquisa(true)}
                                    >
                                        <FaCopy className="me-1" /> Copiar Pesquisa
                                    </Button>

                                    <Button
                                        size="sm"
                                        variant="outline-success"
                                        className="fw-bold extra-small py-0"
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        <FaFileUpload className="me-1" /> Importar TXT / Excel
                                    </Button>

                                    {listaProdutosPesquisa.length > 0 && (
                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            className="fw-bold extra-small py-0"
                                            onClick={() => setListaProdutosPesquisa([])}
                                        >
                                            <FaTrashAlt className="me-1" /> Limpar Todos
                                        </Button>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex gap-2 mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Digite o código EAN, código interno ou descrição..."
                                    value={buscaEanProd}
                                    onChange={e => setBuscaEanProd(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && handleAdicionarProdutoLista()}
                                />
                                <Button className="btn-custom-red fw-bold text-nowrap" onClick={() => handleAdicionarProdutoLista()}>
                                    <FaPlus className="me-1" /> Adicionar
                                </Button>
                            </div>

                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                <Table size="sm" bordered hover className="bg-white small mb-0 text-center align-middle">
                                    <thead className="table-dark sticky-top align-middle">
                                        <tr>
                                            <th>Cód</th>
                                            <th>Descrição</th>
                                            <th>Emb</th>
                                            <th>Preço Floresta</th>
                                            <th>Custo</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaProdutosPesquisa.length > 0 ? (
                                            listaProdutosPesquisa.map((p, idx) => (
                                                <tr key={idx}>
                                                    <td>{p.codigo}</td>
                                                    <td className="text-start fw-bold">{p.descricao}</td>
                                                    <td>{p.emb}</td>
                                                    <td className="fw-bold text-primary">{formatarMoeda(p.preco_loja)}</td>
                                                    <td className="text-muted">{formatarMoeda(p.custo_loja)}</td>
                                                    <td>
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            className="py-0 px-2 fw-bold border-0"
                                                            title="Remover produto da lista"
                                                            onClick={() => setListaProdutosPesquisa(prev => prev.filter(item => item.codigo !== p.codigo))}
                                                        >
                                                            <FaTrashAlt />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-muted py-3">
                                                    Nenhum produto adicionado. Digite acima, importe um ficheiro ou copie de outra pesquisa.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Card>
                    )}

                    <div className="text-end">
                        <Button className="btn-custom-red fw-bold" onClick={handleSalvarNovaPesquisa}>
                            <FaCheckCircle className="me-1" /> Confirmar e Abrir Pesquisa
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showModalCopiarPesquisa} onHide={() => setShowModalCopiarPesquisa(false)} centered>
                <Modal.Header closeButton className="card-header-red py-2 text-white">
                    <Modal.Title className="fs-6 fw-bold">Copiar Produtos de Pesquisa Existente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Selecione a Pesquisa de Origem</Form.Label>
                        <Form.Select
                            value={pesquisaOrigemCopiarId}
                            onChange={e => setPesquisaOrigemCopiarId(e.target.value)}
                        >
                            <option value="">-- Selecione uma Pesquisa --</option>
                            {pesquisas.map(p => {
                                const id = p.pesq_id ?? p.PESQ_ID;
                                const desc = p.pesq_descricao ?? p.PESQ_DESCRICAO;
                                const dt = formatarDataBR(p.dt_inicio ?? p.DT_INICIO);
                                return (
                                    <option key={id} value={id}>
                                        #{id} - {desc} ({dt})
                                    </option>
                                );
                            })}
                        </Form.Select>
                        <Form.Text className="text-muted extra-small mt-1">
                            Todos os produtos da pesquisa selecionada serão importados para a nova lista.
                        </Form.Text>
                    </Form.Group>
                    <div className="text-end">
                        <Button variant="secondary" size="sm" className="me-2 fw-bold" onClick={() => setShowModalCopiarPesquisa(false)}>
                            Cancelar
                        </Button>
                        <Button className="btn-custom-red fw-bold" size="sm" onClick={handleCopiarPesquisaSelecionada}>
                            <FaCopy className="me-1" /> Copiar Produtos
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <ModalListaProdutos
                show={showListaModal}
                produtos={listaProdutosBusca}
                onSelect={(prod) => {
                    setShowListaModal(false);
                    const ok = adicionarItemUnicoNaLista(prod);
                    if (!ok) Swal.fire("Atenção", "Produto já adicionado na lista.", "warning");
                    setBuscaEanProd('');
                }}
                onClose={() => setShowListaModal(false)}
            />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />

            <Footer />
        </div>
    );
}